<template>
  <div class="container py-5">

    <h2 class="page-title mb-4">Web Technology</h2>

    <p class="lead">
      Web technology refers to the tools and techniques used to create websites
      and web-based applications.
    </p>

    <div class="card-section mt-4">
      <h4 class="section-title">🌍 Frontend Technologies</h4>
      <ul>
        <li>HTML</li>
        <li>CSS</li>
        <li>JavaScript</li>
        <li>Vue, React, Angular</li>
      </ul>
    </div>

    <div class="card-section mt-4">
      <h4 class="section-title">🖥 Backend Technologies</h4>
      <ul>
        <li>PHP</li>
        <li>Node.js</li>
        <li>Python (Django, Flask)</li>
        <li>Laravel</li>
      </ul>
    </div>

    <div class="card-section mt-4">
      <h4 class="section-title">⚙ Databases in Web</h4>
      <ul>
        <li>MySQL</li>
        <li>MongoDB</li>
        <li>PostgreSQL</li>
      </ul>
    </div>

  </div>
</template>

<script>
export default {
  name: "WebTechnology",
};
</script>

<style scoped>
.page-title { font-weight: 800; color: #2563eb; }
.lead { color: #374151; font-size: 1.1rem; }
.card-section {
  background: #fff; padding: 20px; border-radius: 16px;
  box-shadow: 0 4px 12px rgba(0,0,0,0.08);
  border-left: 4px solid #2563eb;
}
.section-title { color: #1e40af; font-weight: 600; }
</style>
